import { z } from 'zod'

// Default constants
const DEFAULT_AUFTRAG_3_10 = {
  enabled: true
}

const DEFAULT_AUFTRAG_3_15 = {
  enabled: false
}

const DEFAULT_AUFTRAG_3_20 = {
  enabled: false
}

const DEFAULT_BEFEHL_3_FORM = {
  auftrag_3_10: DEFAULT_AUFTRAG_3_10,
  auftrag_3_15: DEFAULT_AUFTRAG_3_15,
  auftrag_3_20: DEFAULT_AUFTRAG_3_20
}

// Schema definitions
const Auftrag3_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_3_10.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_3_10))

const Auftrag3_15Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_3_15.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_3_15))

const Auftrag3_20Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_3_20.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_3_20))

// Base schema
const Befehl3FormSchemaBase = z
  .object({
    // Auftrag 3.10
    auftrag_3_10: Auftrag3_10Schema,

    // Auftrag 3.15
    auftrag_3_15: Auftrag3_15Schema,

    // Auftrag 3.20
    auftrag_3_20: Auftrag3_20Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_3_FORM))

export const Befehl3FormSchema = Befehl3FormSchemaBase

// Validation schema factory
export const createBefehl3FormValidationSchema = () => {
  return Befehl3FormSchemaBase
}

export type Befehl3FormData = z.infer<typeof Befehl3FormSchemaBase>
